import { FC, ReactNode } from 'react';

interface TopNavProps {
  left: ReactNode;
  right?: ReactNode;
}

const TopNav: FC<TopNavProps> = ({ left, right, children }) => {
  return (
    <header className='fixed w-full h-16 bg-white flex flex-row items-center justify-between shadow-md z-30'>
      {left}
      {right ? right : null}
      {children}
    </header>
  );
};

export default TopNav;
